var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-component"},[_c('router-link',{attrs:{"to":("/" + (_vm.$i18n.locale))}},[_c('img',{style:(_vm.getStyle()),attrs:{"src":"/img/logo.png","alt":"logo City Aventure"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }